import {produce} from 'immer';
import {Drawer, HardwareType} from 'components/customer/Product/entity/Drawer';
import {DrawerRunner} from 'components/customer/Product/entity/DrawerRunner';
import {DrawerSystem} from 'shared/types/DrawerSystem';

// What changing one drawer's type or runner writes to the form, shared by the
// per drawer controls and the cabinet-wide defaults so the two cannot differ.

export type FieldWrite = [path: string, value: unknown];

// an inner drawer's position moves by the difference in bottom clearance, and
// it takes the new system's clearances for the position checks
export const withInnerType = (
    drawer: Drawer,
    current: DrawerSystem,
    selected: DrawerSystem
): Drawer => ({
    ...drawer,
    position_to_bottom:
        drawer.position_to_bottom -
        current.bottomClearance +
        selected.bottomClearance,
    systemTopClearance: selected.topClearance,
    systemBottomClearance: selected.bottomClearance,
    systemInnerDrawerBottomClearance: selected.innerDrawerBottomClearance,
});

// editing swaps only the runner in the saved hardware, which can carry more
export const runnerWrites = (
    index: number,
    drawer: Drawer,
    fieldName: string,
    value: string,
    runner: DrawerRunner,
    isEditingProduct: boolean
): FieldWrite[] => {
    const hardware = {
        hardware_id: runner.hardware_id,
        hardware: {
            type: HardwareType.RUNNER,
        },
    };

    if (isEditingProduct) {
        return [
            [
                `drawers[${index}]`,
                produce(drawer, (draft) => {
                    Object.assign(draft, {[fieldName]: value});
                    draft.drawer_runner_height = runner.runnerHeight;

                    draft.hardware?.forEach((item, at) => {
                        if (item?.hardware?.type == HardwareType.RUNNER) {
                            draft.hardware[Number(at)] = hardware;
                        }
                    });
                }),
            ],
        ];
    }

    return [
        [`drawers[${index}].${fieldName}`, value],
        [`drawers[${index}].drawer_runner_height`, runner.runnerHeight],
        [`drawers[${index}].hardware`, [hardware]],
    ];
};
